export default "__VITE_ASSET__C_3Ov9EW__"